import TeamLogo from "../../../core/modules/TeamLogo";

const styles = {
  index: {
    fontWeight: "bold",
    color: "#000",
    fontSize: "min(max(12px, 1.5vw), 15px)",
  },
  teamName: {
    fontSize: "min(max(15px, 1.4vw), 18px)",
    letterSpacing: 0.5,
  },
};

const renderIndex = (value) => <span style={styles.index}>{value}</span>;

const onCell = () => ({
  style: {
    padding: 0,
    backgroundColor: "transparent",
    borderColor: "#f8f8f8",
  },
});

const renderValue = (text, bold) => {
  const style = {
    fontSize: "15px",
    fontFamily: bold ? "DINNextLTPro-Bold" : null,
    color: bold ? "#1d1d1b" : "#7f7b8e",
    width: "100%",
  };
  return <span style={style}>{text}</span>;
};

const StandingsColumns = [
  {
    key: "index",
    align: "center",
    onCell: () => ({
      style: {
        borderWidth: 3,
        borderColor: "#f8f8f8",
        backgroundColor: "transparent",
      },
    }),
    render: (_text, _record, index) => renderIndex(index + 1),
  },
  {
    dataIndex: "team_logo",
    key: "team_logo",
    align: "center",
    onCell: () => ({
      style: {
        borderColor: "#f8f8f8",
        backgroundColor: "transparent",
        width: 40,
        maxWidth: "100",
      },
    }),
    render: (text) => <TeamLogo name={text} />,
  },
  {
    dataIndex: "team_short_name",
    key: "team_short_name",
    onCell: () => ({
      style: {
        borderColor: "#f8f8f8",
        backgroundColor: "transparent",
        width: "50%",
        maxWidth: 100,
        whiteSpace: "nowrap",
        textOverflow: "ellipsis",
        overflow: "hidden",
      },
    }),
    render: (text) => <span style={styles.teamName}>{text}</span>,
  },
  {
    title: renderValue("PTS", true),
    dataIndex: "points",
    key: "points",
    align: "center",
    onCell,
    render: (text) => renderValue(text, true),
  },
  {
    title: renderValue("J."),
    dataIndex: "played",
    key: "played",
    align: "center",
    onCell,
    render: (text) => renderValue(text),
  },
  {
    title: renderValue("G."),
    dataIndex: "wins",
    key: "wins",
    responsive: ["md"],
    align: "center",
    onCell,
    render: (text) => renderValue(text),
  },
  {
    title: renderValue("N."),
    dataIndex: "draws",
    key: "draws",
    align: "center",
    responsive: ["md"],
    onCell,
    render: (text) => renderValue(text),
  },
  {
    title: renderValue("P."),
    dataIndex: "losts",
    key: "losts",
    align: "center",
    responsive: ["md"],
    onCell,
    render: (text) => renderValue(text),
  },
  {
    title: renderValue("b."),
    dataIndex: "goals_scored",
    key: "goals_scored",
    align: "center",
    responsive: ["md"],
    onCell,
    render: (text) => renderValue(text),
  },
  {
    title: renderValue("e."),
    dataIndex: "goals_conceded",
    key: "goals_conceded",
    align: "center",
    responsive: ["md"],
    onCell,
    render: (text) => renderValue(text),
  },
  {
    title: renderValue("DB"),
    dataIndex: "goals_diff",
    key: "goals_diff",
    align: "center",
    onCell,
    render: (text) => renderValue(text),
  },
];

export default StandingsColumns;
